import React from "react";
import { useParams, Routes, Route, useNavigate } from "react-router-dom";
import { collection, doc, setDoc, deleteDoc } from "firebase/firestore";
import { db } from "../components/Auth/firebase";
import useBoards from "../hooks/useBoards";
import BoardList from "../components/Tasks/Board/BoardList";
import Kanban from "./Kanban";
import { v4 as uuidv4 } from "uuid";
import { useAuth } from "../context/AuthContext";
import { useProjects } from "../context/ProjectsContext";

const Home = ({ name }) => {
  const { currentUser } = useAuth();
  const { activeProject } = useProjects();
  const boards = useBoards(currentUser?.uid, activeProject?.id);
  const { boardId } = useParams();
  const navigate = useNavigate();

  const addNewBoard = (e) => {
    e.preventDefault();
    const uid = uuidv4();
    const projectId = activeProject?.id;

    const boardRef = doc(collection(db, `projects/${projectId}/boards`), uid);
    setDoc(boardRef, { name: e.target.elements.boardName.value })
      .then(() => {
        const columnOrderRef = doc(
          collection(db, `projects/${projectId}/boards/${uid}/columns`),
          "columnOrder"
        );
        return setDoc(columnOrderRef, { id: "columnOrder", order: [] });
      })
      .then(() => {
        e.target.elements.boardName.value = "";
        console.log("New board added successfully!");
      })
      .catch((error) => {
        console.error("Error adding new board:", error);
      });
  };

  const deleteBoard = async (id) => {
    const projectId = activeProject?.id;
    const boardRef = doc(db, `projects/${projectId}/boards`, id);
    await deleteDoc(boardRef);
    navigate(`/tasks`); // Navigate back to boards list
  };

  return boards !== null ? (
    <Routes>
      <Route
        path="/"
        element={
          <BoardList
            deleteBoard={deleteBoard}
            boards={boards}
            addNewBoard={addNewBoard}
            name={name}
          />
        }
      />
      <Route
        path="boards/:boardId"
        element={<Kanban userId={currentUser.uid} boardId={boardId} />}
      />
    </Routes>
  ) : (
    <div className="spinner h-screen w-screen" />
  );
};

export default Home;
